import React from "react";
import { View, StyleSheet, Animated } from "react-native";
import CustomText from "@components/CustomText";

export default function DropdownList(props) {
  const {
    totalItems,
    completed,
    placeholder = "",
    width = 50,
    progressStyle = {},
    containerStyle = {},
    textStyle = {},
  } = props;

  return (
    <View
      style={[{ flexDirection: "row", alignItems: "center" }, containerStyle]}
    >
      <View style={[styles.progressBar, progressStyle]}>
        <Animated.View
          style={
            ([StyleSheet.absoluteFill],
            {
              backgroundColor: "#27AE60",
              width: `${(completed / totalItems) * 100}%`,
              borderRadius: 10,
            })
          }
        />
      </View>
      <CustomText variant="body_text_2" style={[styles.text, textStyle]}>
        {`${Math.floor((completed / totalItems) * 100)}%`}
      </CustomText>
    </View>
  );
}

const styles = StyleSheet.create({
  progressBar: {
    flexDirection: "row",
    height: 6,
    flex: 1,
    marginRight: 8,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    borderRadius: 10,
  },
  text: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: "bold",
  },
});
